import {
  FileFormField,
  FormField,
  SingleFormField,
} from '@/forms/typings';
import { fieldModuleRegistry } from '@/forms/field-modules/registry';

export const adaptFormDataToFormField = (
  formData: FormField[],
): Array<SingleFormField | FileFormField> => {
  return formData.flatMap(field => {
    const naDetailsFlat = field.naDetails
      ? adaptFormDataToFormField([field.naDetails])
      : [];

    const mod = fieldModuleRegistry.get(field.type);
    const baseFlat = mod.flattenLeaves(field, {
      recurse: adaptFormDataToFormField,
    });

    return [...baseFlat, ...naDetailsFlat];
  });
};
